import { useEffect, useState } from "react";
import { Clock, LayoutDashboard } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../components/ui/dialog";
import { useWorkspace } from "../../store/WorkspaceContext";
import { useAuth } from "../../store/AuthContext";

// Pops up once per session, as soon as the app opens, for trial customers on their last day.
export const TrialAlertDialog = () => {
  const { user } = useAuth();
  const { dispatch } = useWorkspace();
  const [open, setOpen] = useState(false);
  const lastDay = user && user.role !== "admin" && user.plan_state === "trial" && user.entitled && (user.trial_days_left ?? 99) <= 1;
  const key = `xpattern.trialAlert.${user?.id || "x"}.${user?.trial_ends_at || ""}`;
  useEffect(() => {
    if (!lastDay || sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    setOpen(true);
  }, [lastDay, key]);
  if (!lastDay) return null;
  const ends = user.trial_ends_at ? new Date(user.trial_ends_at).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "today";
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="panel3d max-w-md border-[#f5a524]/40 bg-[#121824] text-[#e8e9ec]" data-testid="trial-alert-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[16px] text-[#f5c542]"><Clock className="h-5 w-5" /> Last day of your free trial</DialogTitle>
          <DialogDescription className="text-[13px] leading-relaxed text-[#c7cbd1]">
            Your Xpattern trial ends <b className="text-[#e8e9ec]">{ends}</b>. After that, cutting is paused until you subscribe.
            <br /><br />Go to <b className="text-[#e8e9ec]">My Dashboard</b> (click your name at the top right) and press <b className="text-[#e8e9ec]">Buy Subscription</b> — $79.99 / month or $899.99 / year — to keep cutting without interruption.
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-2 pt-1">
          <button data-testid="trial-alert-later-btn" onClick={() => setOpen(false)} className="btn flex-1">Later</button>
          <button data-testid="trial-alert-dashboard-btn" onClick={() => { setOpen(false); dispatch({ type: "SET", patch: { dialog: "profile" } }); }} className="btn-red flex-1"><LayoutDashboard className="h-4 w-4" /> Open My Dashboard</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
